import { OpalApiRequestParams } from '@opallabs/api'

export const queryKeys = {
  inMarketContent: ({
    workspace_id,
    query,
  }: {
    workspace_id: string
    query?: OpalApiRequestParams<'ReadInMarketBFFV1'>['query']
  }) => {
    return query
      ? [workspace_id, 'in_market', query]
      : [workspace_id, 'in_market']
  },
}
